<ng-container *ngFor="let toast of availableToasts; index as i; trackBy: trackToasts">
  <app-toast
    [toastMsg]="toast"
    (expire)="expireToast($event)"
  ></app-toast>
</ng-container>
